import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Commission extends Model<Schemas['commissions'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }
}
